import { createFileRoute } from '@tanstack/react-router';
import EcoDriveOnline from '../../../components/Graphs/EcoDrive/EcoDriveOnline';

export const Route = createFileRoute('/_authenticated/graphs/eco_drive/$vehicleId')({
  beforeLoad: ({ context }) => {
    // No permission gate: matches the original (wouter) router and the sibling graph routes,
    // which render for any logged-in user (no `access` prop).
    return {
      ...context,
      documentTitle: {
        main: 'rides.ecoScore',
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EcoDriveGraphRoute,
});

function EcoDriveGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <EcoDriveOnline vehicleId={Number(vehicleId)} isPage />;
}
